export const FETCH_RECENT_CONVERSATIONS =
  'integrations/recentConversations/FETCH_RECENT_CONVERSATIONS'
export const FETCH_RECENT_CONVERSATIONS_SUCCESS =
  'integrations/recentConversations/FETCH_RECENT_CONVERSATIONS_SUCCESS'

export const ROOM = 'ROOM'
export const CONVERSATION = 'CONVERSATION'
